<template>
  <div class="sp-alert-content">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
@import "sp-alert-content";
</style>
